import { type Transition, type Variant, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

export enum DeathGameSharedVariant {
    Initial = 'sharedInitial',
    Show = 'sharedShow',
    Exit = 'sharedExit',
}

const deathGameCommonTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
    staggerChildren: framerMotion.duration.fast,
};

const deathGameHiddenVariant: Variant = {
    opacity: 0,
    transition: {
        ...deathGameCommonTransition,
        when: 'afterChildren',
    },
};

export const deathGameVariants: Variants = {
    [DeathGameSharedVariant.Initial]: deathGameHiddenVariant,
    [DeathGameSharedVariant.Exit]: deathGameHiddenVariant,
    [DeathGameSharedVariant.Show]: {
        opacity: 1,
        transition: {
            ...deathGameCommonTransition,
            staggerDirection: -1,
            when: 'beforeChildren',
        },
    },
};
